import './Icon.scss';

import React from 'react';
import PropTypes from 'prop-types';

const Icon = ({className, type}) => {
    const generateClass = (type, className) => {
        let classString = `c-icon a-icon--${type}`;
        if (className != null) {
            classString += ` ${className}`;
        }
        return classString;
    };

    switch (type) {
        case 'caret-right':
            return (
                <svg className={generateClass(type, className)} viewBox="0 0 9.1 15.4">
                    <path d="M1.4,15.4L0,14l6.3-6.3L0,1.4L1.4,0l7.7,7.7L1.4,15.4z" />
                </svg>
            );
        case 'plus':
            return (
                <svg className={generateClass(type, className)} viewBox="0 0 24 24">
                    <path d="M24,15H0V9h24V15z" />
                    <path d="M9,0h6v24H9V0z" />
                </svg>
            );
        case 'search':
            return (
                <svg className={generateClass(type, className)} viewBox="0 0 20.8 19.7">
                    <path d="M8,16c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S12.4,16,8,16z M8,2C4.7,2,2,4.7,2,8s2.7,6,6,6s6-2.7,6-6S11.3,2,8,2z" />
                    <path d="M19.8,19.7c-0.2,0-0.5-0.1-0.6-0.2l-6.8-5.7c-0.4-0.4-0.5-1-0.1-1.4c0.4-0.4,1-0.5,1.4-0.1l6.8,5.7c0.4,0.4,0.5,1,0.1,1.4C20.4,19.5,20.1,19.7,19.8,19.7z" />
                </svg>
            );
        case 'user':
            return (
                <svg className={generateClass(type, className)} viewBox="0 0 512 512">
                    <path d="M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z" />
                </svg>
            );
        case 'x':
            return (
                <svg className={generateClass(type, className)} viewBox="0 0 319.99 319.99">
                    <path d="M193.94,160,296.5,57.44l21.15-21.15a8,8,0,0,0,0-11.31L295,2.35a8,8,0,0,0-11.31,0L160,126.06,36.29,2.34A8,8,0,0,0,25,2.34L2.34,25a8,8,0,0,0,0,11.31L126.06,160,2.34,283.71a8,8,0,0,0,0,11.31L25,317.65a8,8,0,0,0,11.31,0L160,193.94,262.56,296.5l21.15,21.15a8,8,0,0,0,11.31,0L317.65,295a8,8,0,0,0,0-11.31Z"/>
                </svg>
            );
        default:
            return null;
    }
};

Icon.propTypes = {
    className: PropTypes.string,
    type: PropTypes.string.isRequired,
};

export default Icon;
